module.exports = __webpack_public_path__ + "img/黄金邮轮.9bc2022b.gif";